export interface IChatHistory {
  session_id: string
  tenant_id: number
  user_id: number
  global_context_id: string
  created_at: number
  feature: string
  title: string
  user_role: string
  active_session_type: string
  authorizer_id: string
  updated_at: string
  is_active: boolean
}

export interface IMessageSource {
  id: number
  cdnLink: string
  urlLink: string
  name: string
  sourceType: string
  description: string
  sourceName: string
  containsFinancialInfo?: boolean
}

export interface IMessage {
  id?: string
  actor: string
  text: string
  timestamp: number
  source?: IMessageSource[]
  score?: {
    score_category?: string
  }
  gptSource?: any
  isPending?: boolean
  docs?: any
  llmVerifiedSources?: any
  web_search_results?: any
  attachedFiles?: { name: string; fileId?: string }[]
  files?: { name: string; id: string }[]
  msg_id?: string
  status?: string
  researchEnabled?: boolean
  context_quote?: string
  pptMetadata?: any
  user_email?: string
  user_id?: string | number
  suggestions?: SuggestionItem[]
}

export type SuggestionItem = string | { label: string; prompt: string }

export const getSuggestionLabel = (s: SuggestionItem): string =>
  typeof s === "string" ? s : s.label

export const getSuggestionPrompt = (s: SuggestionItem): string =>
  typeof s === "string" ? s : s.prompt

export interface ITag {
  id: number
  name: string
}
